import {create} from 'zustand';
import type {AxiosResponse} from 'axios';
import {SILENT_FEATURE_DISABLED_CODE} from '@/utils/api-error-code';

interface FissionV4AvailabilityState {
  wheelEnabled: boolean;
  setWheelEnabled: (enabled: boolean) => void;
}

export const useFissionV4AvailabilityStore = create<FissionV4AvailabilityState>(
  set => ({
    wheelEnabled: true,
    setWheelEnabled: wheelEnabled => set({wheelEnabled}),
  }),
);

export const isFissionV4DisabledError = (error: unknown) =>
  (error as AxiosResponse<{code?: number}>)?.data?.code ===
  SILENT_FEATURE_DISABLED_CODE;
